// Modules
import React, { Children, cloneElement, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Spinner } from '@blueprintjs/core'
import PropTypes from 'prop-types'

// Components
import Header from './components/header/Header'
import Meta from 'components/utility/meta/Meta'
import Section from './components/section/Section'
import View from './components/view/View'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Helpers
import { scrollToSection } from 'helpers/layout'
import { convertFontSizeToPixelSize } from 'helpers/size'

// Utilities
import { camelCaseSlug } from 'utilities/text'

// Styles
import './Page.scss'

// Component: Layout > Page
function Page ({ children, className, isLoading, isPublic, name, path, style, view }) {
	// Data
	// const { translate } = useLanguage('components.layout.page')
	const { hash } = useLocation()

	// Functions
	function renderChildren () {
		return Children.map(children, child => {
			if (!child || !child.props) return child
			return cloneElement(child, child.props)
		})
	}

	// Effects
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [name, view])
	useEffect(() => {
		if (!!hash) {
			const sectionName = hash.slice(1)
			if (!!sectionName) scrollToSection(sectionName, true)
		}
	}, [hash])

	// Render
	return (
		<main
			id="page"
			data-page={name}
			data-view={view}
			data-layout="page"
			className={
				'aix-page' +
				(isLoading ? ' aix-loading' : '') +
				(isPublic ? ' aix-public' : '') +
				(className ? ` ${className}` : '')
			}
			style={style}>
			<Meta
				path={path}
				page={camelCaseSlug(name)} />
			{isLoading
				? <Spinner size={convertFontSizeToPixelSize('2rem')} />
				: renderChildren()
			}
		</main>
	)
}

// Properties
Page.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	isLoading: PropTypes.bool,
	isPublic: PropTypes.bool,
	name: PropTypes.string.isRequired,
	path: PropTypes.string,
	preview: PropTypes.string,
	style: PropTypes.object,
	view: PropTypes.string
}
Page.defaultProps = {
	isLoading: false,
	isPublic: false
}
Page.Header = Header
Page.Header.displayName = 'Page.Header'
Page.Section = Section
Page.Section.displayName = 'Page.Section'
Page.View = View
Page.View.displayName = 'Page.View'

// Export
export default Page
